import api from "./axios";

// Кабинет physician: команда медсестёр (test_administrator) + статистика

export interface TeamMember {
  id: string;
  email: string;
  role: string;
  name: string | null;
  surname: string | null;
  is_active: boolean;
  physician_id: string | null;
}

export interface PhysicianStats {
  patients_total: number;
  scans_total: number;
  by_sex: Record<string, number>;
  patients_by_day: { date: string; count: number }[];
  scans_by_day: { date: string; count: number }[];
  team_size: number;
  tz: string;
}

export async function listTeam(): Promise<TeamMember[]> {
  const res = await api.get("/physician/team");
  return res.data;
}

export async function createTeamMember(body: {
  email: string;
  password: string;
  name: string;
  surname: string;
}): Promise<TeamMember> {
  const res = await api.post("/physician/team", body);
  return res.data;
}

export async function updateTeamMember(
  memberId: string,
  body: { name?: string; surname?: string; password?: string; is_active?: boolean }
): Promise<TeamMember> {
  const res = await api.patch(`/physician/team/${memberId}`, body);
  return res.data;
}

export async function getPhysicianStats(tz: string): Promise<PhysicianStats> {
  const res = await api.get("/physician/stats", { params: { tz } });
  return res.data;
}

// Админ: сводка по всем врачам + разбивка по их медсёстрам

export interface OverviewPerson {
  id: string;
  email: string | null;
  name: string | null;
  surname: string | null;
  is_active: boolean;
  patients_created: number;
  scans_conducted: number;
}

export interface PhysicianOverviewEntry extends OverviewPerson {
  patients_total: number;
  scans_total: number;
  last_scan_at: string | null;
  members: OverviewPerson[];
}

export async function getPhysiciansOverview(): Promise<{ physicians: PhysicianOverviewEntry[] }> {
  const res = await api.get("/physician/overview");
  return res.data;
}
